module.exports = __webpack_public_path__ + "img/11.156a72fa.jpg";